import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { CircularProgress } from '@mui/material';

const Button = ({
  children,
  loading = false,
  startIcon,
  endIcon,
  ...props
}) => {
  return (
    <MuiButton
      {...props}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      disabled={loading || props.disabled}
    >
      {loading ? (
        <>
          <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
          {children}
        </>
      ) : (
        children
      )}
    </MuiButton>
  );
};

export default Button;
